import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table, Modal, Spinner, Alert } from "react-bootstrap";
import { FaTrash, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AddPurchase.css";

const AddDeliveryNote = () => {
  const [formData, setFormData] = useState({
    customer_id: "",
    date: new Date().toISOString().split('T')[0],
    invoice_no: "",
    delivery_address: "",
    vehicle_no: "",
    driver_name: "",
    bundel_count: "",

    driver_phone: "",
    notes: "",
    productSearch: "",
    selectedProduct: null,
    qty: "",
    order_id: "",
    is_order_based: false
  });

  const [deliveryItems, setDeliveryItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [showInvoiceDropdown, setShowInvoiceDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [selectedCustomerAddress, setSelectedCustomerAddress] = useState("");

  // Add new state for orders
  const [orders, setOrders] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0.00);
  const [showOrderDropdown, setShowOrderDropdown] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);


  // Customer modal states
  const [newCustomer, setNewCustomer] = useState({
    name: "",
    mobile: "",
    address: "",
    gst_no: "",
    state: "",
    city: "",
    pin_code: ""
  });
  const [customerErrors, setCustomerErrors] = useState({});
  const [isAddingCustomer, setIsAddingCustomer] = useState(false);
  const [customerSuccess, setCustomerSuccess] = useState("");

  // Refs for input fields
  const customerRef = useRef(null);
  const dateRef = useRef(null);
  const invoiceNoRef = useRef(null);
  const vehicleNoRef = useRef(null);
  const driverNameRef = useRef(null);
  const driverPhoneRef = useRef(null);
  const productSearchRef = useRef(null);
  const qtyRef = useRef(null);
  const bundelRef = useRef(null);

  const rateRef = useRef(null);
  const notesRef = useRef(null);
  const submitBtnRef = useRef(null);

  // For keyboard navigation in dropdowns
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);

  const navigate = useNavigate();

  // Fetch customers, products, and invoices from API
  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      // Fetch customers
      const customersResponse = await api.post("/customer_list.php", {});
      if (customersResponse.data.head.code === 200) {
        setCustomers(customersResponse.data.body);
      }

      // Fetch products with current stock
      const productsResponse = await api.post("/product_list.php", {});
      if (productsResponse.data.head.code === 200) {
        setProducts(productsResponse.data.body);
      }

      // Fetch invoices for dropdown
      // const invoicesResponse = await api.post("/invoice_list.php", {});
      const invoicesResponse = await api.post("/order_list_dropdown.php", {});
      if (invoicesResponse.data.head.code === 200) {
        setInvoices(invoicesResponse.data.body);
      }
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
    }
  };

  // Function to fetch invoice details and auto-populate items
  const fetchInvoiceDetails = async (invoiceNo) => {
    try {
      const response = await api.post("/order_detail.php", { id: invoiceNo });
      if (response.data.head.code === 200) {
        const invoiceData = response.data.body;
        console.log("invoiceData", invoiceData);
        // Set customer if not already selected
        if (!formData.customer_id && invoiceData.customer_id) {
          setFormData(prev => ({
            ...prev,
            customer_id: invoiceData.customer_id,
            invoice_no: invoiceNo,
            selectedProduct: invoiceData.items,
          }));

          // Set customer address
          const selectedCustomer = customers.find(c => c.id == invoiceData.customer_id);
          if (selectedCustomer) {
            const addressParts = [];
            if (selectedCustomer.address) addressParts.push(selectedCustomer.address);
            if (selectedCustomer.city) addressParts.push(selectedCustomer.city);
            if (selectedCustomer.state) addressParts.push(selectedCustomer.state);
            if (selectedCustomer.pin_code) addressParts.push(selectedCustomer.pin_code);
            setSelectedCustomerAddress(addressParts.join(", "));
          }
        }

        // Add invoice items to delivery items
        if (invoiceData.items && invoiceData.items.length > 0) {
          const newItems = invoiceData.items.map(item => {
            // Find product in product list to get current stock
            console.log("from line 139", item.id);
            const product = products.find(p =>
              p.id == item.product_id ||
              p.code == item.product_code ||
              p.name == item.product_name
            );

            return {
              order_item_id: item.id || 0,
              product_id: product?.id || item.product_id || "",
              product_code: product?.code || item.product_code || "",
              product_name: product?.name || item.product_name || "",
              current_stock: product?.stock || 0,
              selling_rate: item.selling_rate || 0,
              delivery_qty: 0,
              pending_qty: item.pending_qty || 0,
              // unit: product?.unit_name || "==="
            };
          });

          setDeliveryItems(newItems);
          alert(`Invoice #${invoiceNo} loaded with ${newItems.length} items. Please enter delivery quantities.`);
        }
      }
    } catch (err) {
      console.error("Error fetching invoice details:", err);
      alert("Failed to fetch invoice details.");
    }
  };

  // Handle invoice input change with auto-fetch
  const handleInvoiceChange = async (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, invoice_no: value }));

    if (value.trim().length > 0) {
      setShowInvoiceDropdown(true);
    } else {
      setShowInvoiceDropdown(false);
    }

    // Auto-fetch if it looks like a complete invoice number
    if (value.trim().length >= 3) {
      await fetchInvoiceDetails(value);
    }
  };

  // Filter products based on search input
  const getFilteredProducts = () => {
    if (!formData.productSearch) {
      return products.slice(0, 10);
    }

    const searchTerm = formData.productSearch.toLowerCase();
    const filtered = products.filter(product => {
      const productName = product.name || product.product_name || "";
      const productCode = product.id || "";
      return (
        productName.toLowerCase().includes(searchTerm) ||
        productCode.toLowerCase().includes(searchTerm)
      );
    });
    return filtered.slice(0, 10);
  };

  // Filter invoices based on search input
  const getFilteredInvoices = () => {
    if (!formData.invoice_no) {
      return invoices.slice(0, 10);
    }

    const searchTerm = formData.invoice_no.toLowerCase();
    // const filtered = invoices.filter(invoice => {
    //   const invoiceNo = invoice.invoice_no || invoice.id || "";
    //   const customerName = invoice.customer_name || "";
    //   return (
    //     invoiceNo.toString().toLowerCase().includes(searchTerm) ||
    //     customerName.toLowerCase().includes(searchTerm)
    //   );
    // });
    const filtered = invoices.filter(invoice => {
      const invoiceNo = invoice.id || "";
      const customerName = invoice.customer_name || "";
      return (
        invoiceNo.toString().toLowerCase().includes(searchTerm) ||
        customerName.toLowerCase().includes(searchTerm)
      );
    });
    return filtered.slice(0, 10);
  };




  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("====== test ========");
    if (name === 'customer_id') {
      const selectedCustomer = customers.find(c => c.id == value);
      if (selectedCustomer) {
        const addressParts = [];
        if (selectedCustomer.address) addressParts.push(selectedCustomer.address);
        if (selectedCustomer.city) addressParts.push(selectedCustomer.city);
        if (selectedCustomer.state) addressParts.push(selectedCustomer.state);
        if (selectedCustomer.pin_code) addressParts.push(selectedCustomer.pin_code);
        setSelectedCustomerAddress(addressParts.join(", "));
      } else {
        setSelectedCustomerAddress("");
      }
    } else if (name === 'invoice_no') {
      handleInvoiceChange(e);
      return;
    }

    // ✅ Update state + log
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      console.log("===========", updated.rate, updated.qty);
      // 🔍 PRINT HERE
      console.log("line 256 name", name);
      if (name === 'rate' || name === 'qty') {
        console.log("Rate:", updated.rate);
        console.log("Delivery Qty:", updated.qty);
        console.log("Total:", (Number(updated.rate) || 12) * (Number(updated.qty) || 3));
        // setTotalAmount((Number(updated.rate) || 0) * (Number(updated.qty) || 0).toFixed(2));
      }

      return updated;
    });

    if (name === 'productSearch') {
      setShowProductDropdown(true);
      setActiveDropdown('product');
      setActiveIndex(-1);
    } else if (name === 'invoice_no' && value.length === 0) {
      setShowInvoiceDropdown(true);
      setActiveDropdown('invoice');
      setActiveIndex(-1);
    }
  };

  // Handle keyboard navigation in dropdowns
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showProductDropdown && !showInvoiceDropdown) return;

      const filteredItems = activeDropdown === 'product'
        ? getFilteredProducts()
        : getFilteredInvoices();

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          setActiveIndex(prev =>
            prev < filteredItems.length - 1 ? prev + 1 : prev
          );
          break;

        case 'ArrowUp':
          e.preventDefault();
          setActiveIndex(prev => prev > 0 ? prev - 1 : -1);
          break;

        case 'Enter':
          e.preventDefault();
          if (activeIndex >= 0 && filteredItems[activeIndex]) {
            if (activeDropdown === 'product') {
              handleProductSelect(filteredItems[activeIndex]);
            } else {
              handleInvoiceSelect(filteredItems[activeIndex]);
            }
          } else if (activeDropdown === 'product' && filteredItems.length === 1 && formData.productSearch) {
            handleProductSelect(filteredItems[0]);
          } else if (activeDropdown === 'product' && formData.productSearch && filteredItems.length > 0) {
            rateRef.current.focus();
          }
          break;

        case 'Escape':
          e.preventDefault();
          if (activeDropdown === 'product') {
            setShowProductDropdown(false);
          } else {
            setShowInvoiceDropdown(false);
          }
          setActiveIndex(-1);
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showProductDropdown, showInvoiceDropdown, activeIndex, activeDropdown, formData]);

  // Handle product selection from dropdown
  const handleProductSelect = (product) => {
    const productName = product.name || product.product_name || "";
    // const productCode = product.id || "";
    const productId = product.id; // assume this comes from your product object

    const productCode = `PROD${productId.toString().length === 1
      ? "0" + productId
      : productId
      }`;
    const currentStock = product.stock || 0;

    setFormData(prev => ({
      ...prev,
      productSearch: `${productCode} - ${productName}`,
      selectedProduct: {
        id: product.id,
        product_code: productCode,
        product_name: productName,
        current_stock: currentStock
      }
    }));
    setShowProductDropdown(false);
    setActiveIndex(-1);
    rateRef.current.focus();
  };

  // Handle invoice selection from dropdown
  const handleInvoiceSelect = (invoice) => {
    const invoiceNo = invoice.invoice_no || invoice.id || "";
    setFormData(prev => ({
      ...prev,
      invoice_no: invoiceNo.toString(),
    }));
    setShowInvoiceDropdown(false);
    setActiveIndex(-1);

    // Fetch invoice details
    fetchInvoiceDetails(invoiceNo);
  };

  const handleAddItem = () => {
    if (!formData.selectedProduct || !formData.qty) {
      alert("Please select a product and enter quantity");
      return;
    }

    const deliveryQty = parseInt(formData.qty);
    const currentStock = formData.selectedProduct.current_stock || 0;

    if (deliveryQty <= 0) {
      alert("Delivery quantity must be greater than 0");
      return;
    }

    if (deliveryQty > currentStock) {
      alert(`Delivery quantity (${deliveryQty}) cannot exceed current stock (${currentStock})`);
      return;
    }

    const newItem = {
      product_id: formData.selectedProduct.id,
      product_code: formData.selectedProduct.product_code,
      product_name: formData.selectedProduct.product_name,
      selling_rate: formData.selectedProduct.selling_rate || formData.rate,
      current_stock: currentStock,
      delivery_qty: deliveryQty
      // unit: "PCS"
    };

    setDeliveryItems([...deliveryItems, newItem]);

    // Reset product fields only
    setFormData(prev => ({
      ...prev,
      productSearch: "",
      rate: "",
      selectedProduct: null,
      qty: ""
    }));

    // Focus back on product search for next entry
    productSearchRef.current.focus();
    setShowProductDropdown(false);
    setActiveIndex(-1);
  };

  // Enter key navigation handler
  const handleKeyPress = (e, nextFieldRef, action = null) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (action) {
        action();
      } else if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus();
      }
    }
  };

  // Special handler for quantity field to add item
  const handleQtyKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddItem();
    }
  };

  const handleItemChange = (index, value) => {
    console.log("======= test line 438 =========");
    const updatedItems = [...deliveryItems];
    const deliveryQty = parseInt(value) || 0;
    const currentStock = updatedItems[index].current_stock || 0;
    // setTotalAmount(updatedItems[index].selling_rate * deliveryQty);

    if (deliveryQty <= 0) {
      alert("Delivery quantity must be greater than 0");
      return;
    }

    if (deliveryQty > currentStock) {
      alert(`Delivery quantity (${deliveryQty}) cannot exceed current stock (${currentStock})`);
      return;
    }

    updatedItems[index].delivery_qty = deliveryQty;
    setDeliveryItems(updatedItems);
  };

  const handleDeleteItem = (index) => {
    const updatedItems = deliveryItems.filter((_, i) => i !== index);
    setDeliveryItems(updatedItems);
  };

  // Customer Modal Functions (same as before)
  const handleShowCustomerModal = () => {
    setShowCustomerModal(true);
    setCustomerErrors({});
    setCustomerSuccess("");
  };

  const handleCloseCustomerModal = () => {
    setShowCustomerModal(false);
    setNewCustomer({
      name: "",
      mobile: "",
      address: "",
      gst_no: "",
      state: "",
      city: "",
      pin_code: ""
    });
    setCustomerErrors({});
    setCustomerSuccess("");
    setIsAddingCustomer(false);
  };

  // Handle new customer form change
  const handleNewCustomerChange = (e) => {
    const { name, value } = e.target;
    setNewCustomer(prev => ({ ...prev, [name]: value }));
    if (customerErrors[name]) {
      setCustomerErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  // Validate customer form
  const validateCustomer = () => {
    const errors = {};

    if (!newCustomer.name.trim()) {
      errors.name = "Customer name is required";
    }

    if (!newCustomer.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(newCustomer.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number";
    }

    return errors;
  };

  // Handle adding customer via API
  const handleAddCustomer = async () => {
    const validationErrors = validateCustomer();

    if (Object.keys(validationErrors).length > 0) {
      setCustomerErrors(validationErrors);
      return;
    }

    try {
      setIsAddingCustomer(true);
      setCustomerSuccess("");
      setCustomerErrors({});

      const payload = {
        name: newCustomer.name,
        mobile: newCustomer.mobile,
        gst_no: newCustomer.gst_no || "",
        state: newCustomer.state || "",
        city: newCustomer.city || "",
        address: newCustomer.address || "",
        pin_code: newCustomer.pin_code || ""
      };

      const response = await api.post("/customer_add.php", payload);

      if (response.data.head.code === 200) {
        const newCustomerObj = {
          id: response.data.body.customer_id,
          name: newCustomer.name,
          mobile: newCustomer.mobile,
          gst_no: newCustomer.gst_no,
          state: newCustomer.state,
          city: newCustomer.city,
          address: newCustomer.address,
          pin_code: newCustomer.pin_code
        };

        setCustomers(prev => [...prev, newCustomerObj]);

        setFormData(prev => ({
          ...prev,
          customer_id: response.data.body.customer_id
        }));

        const addressParts = [];
        if (newCustomer.address) addressParts.push(newCustomer.address);
        if (newCustomer.city) addressParts.push(newCustomer.city);
        if (newCustomer.state) addressParts.push(newCustomer.state);
        if (newCustomer.pin_code) addressParts.push(newCustomer.pin_code);
        setSelectedCustomerAddress(addressParts.join(", "));

        setCustomerSuccess(`Customer "${newCustomer.name}" added successfully!`);

        setTimeout(() => {
          handleCloseCustomerModal();
          if (customerRef.current) {
            customerRef.current.focus();
          }
        }, 2000);

      } else {
        const errorMsg = response.data.head.msg || "Failed to add customer";
        setCustomerErrors({ api: errorMsg });
      }
    } catch (err) {
      console.error("Error adding customer:", err);

      let errorMessage = "Failed to add customer. Please try again.";

      if (err.response) {
        errorMessage = err.response.data?.head?.msg || errorMessage;
      } else if (err.request) {
        errorMessage = "No response from server. Please check your connection.";
      }

      setCustomerErrors({ api: errorMessage });
    } finally {
      setIsAddingCustomer(false);
    }
  };

  // Handle keydown in customer modal
  const handleCustomerKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAddCustomer();
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.customer_id) newErrors.customer_id = "Customer is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (deliveryItems.length === 0) newErrors.items = "At least one item is required";

    // Validate that all items have delivery quantity
    const invalidItems = deliveryItems.filter(item => (!item.delivery_qty || item.delivery_qty <= 0) && (item.pending_qty != 0));
    if (invalidItems.length > 0) {
      newErrors.items = "All items must have a delivery quantity greater than 0";
    }

    return newErrors;
  };
  /*
    // Function to update product stock
    const updateProductStock = async (productId, deliveryQty) => {
      try {
        const payload = {
          product_id: productId,
          quantity: deliveryQty,
          action: "decrease" // This tells the API to decrease stock
        };
  
        const response = await api.post("/product_update_stock.php", payload);
        return response.data.head.code === 200;
      } catch (err) {
        console.error("Error updating product stock:", err);
        return false;
      }
    };
  */
  const formatDateToDMY = (date) => {
    if (!date) return "";
    const [yyyy, mm, dd] = date.split("-");
    return `${dd}-${mm}-${yyyy}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      setLoading(true);
      setSubmitError("");

      // Prepare payload for delivery note
      const payload = {
        customer_id: parseInt(formData.customer_id) || 0,
        date: formatDateToDMY(formData.date),
        vehicle_no: formData.vehicle_no || 0,
        driver_name: formData.driver_name || "",
        bundel_count: formData.bundel_count || "",


        driver_phone: formData.driver_phone || "",
        delivery_address: formData.delivery_address || selectedCustomerAddress || "",
        order_id: formData.invoice_no || 0,
        notes: formData.notes || "",
        subtotal: subTotal || 0,
        gst_per: formData.gst_percentage || 18,
        gst_amount: gstAmount || 0,
        total: grandTotal || 0,
        // items: deliveryItems.map(item => ({
        items: deliveryItems.map((item, index) => {
          console.log("Mapped Item:", index, item);
          return {
            order_item_id: item.order_item_id,
            product_id: item.product_id,
            selling_rate: item.selling_rate,
            delivery_qty: item.delivery_qty,
            total_amount: item.selling_rate * item.delivery_qty
          };
          // unit: item.unit
        })
      };
      console.log("delivery note payload is: ", payload);
      /* */
      // Step 1: Create delivery note
      const response = await api.post("/delivery_note_add.php", payload);

      if (response.data.head.code === 200) {
        const deliveryNoteId = response.data.body.delivery_note_id;
        /*
                // Step 2: Update product stock for each item
                const stockUpdatePromises = deliveryItems.map(item =>
                  updateProductStock(item.product_id, item.delivery_qty)
                );
        
                const stockUpdateResults = await Promise.all(stockUpdatePromises);
                const allStockUpdated = stockUpdateResults.every(result => result === true);
        
                if (allStockUpdated) {
                  alert(`Delivery Note #${deliveryNoteId} created successfully! Product stock updated.`);
                  navigate("/delivery-note-list");
                } else {
                  // If stock update failed, show warning but still created delivery note
                  alert(`Delivery Note #${deliveryNoteId} created, but some product stock updates failed. Please check stock manually.`);
                  navigate("/delivery-note-list");
                }
                */
        navigate("/deliverynote");
      } else {
        const errorMsg = response.data.head.msg || "Failed to create delivery note";
        setSubmitError(errorMsg);
      }

    } catch (err) {
      console.error("Error creating delivery note:", err);
      setSubmitError("Failed to create delivery note. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  const renderCustomerError = (field) =>
    customerErrors[field] ? (
      <div className="text-danger small mt-1">{customerErrors[field]}</div>
    ) : null;
  /*
    var finalTotal = 0.00;
  
    const calculateSubTotal = () => {
      return finalTotal += totalAmount;
      // return totalAmount;
    };
  
    const calculateGST = () => {
  
      // const subTotal = calculateSubTotal();
      // console.log("====== from line 720 ==========",subTotal);
      // return (subTotal * (parseFloat(formData.gst_percentage) / 100));
      const subTotal = Number(calculateSubTotal()) || 0;
      const gstPercentage = Number(formData.gst_percentage) || 0;
      console.log("############# ", subTotal, gstPercentage);
      return (subTotal * gstPercentage) / 100;
  
    };
  
    const calculateGrandTotal = () => {
  
      const subTotal = calculateSubTotal();
      const gst = calculateGST();
      console.log("Final Total:", subTotal, gst);
      return subTotal + gst;
    };
  */
  const handleGstChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, gst_percentage: value }));
  };
  const subTotal = deliveryItems.reduce((sum, item) => {
    return sum + (Number(item.selling_rate || 0) * Number(item.delivery_qty || 0));
  }, 0);
  const gstPercentage = Number(formData.gst_percentage || 18);
  const gstAmount = (subTotal * gstPercentage) / 100;
  const grandTotal = subTotal + gstAmount;

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Create Delivery Note</h4>
        <Button className="btn-top" onClick={() => navigate(-1)} disabled={loading}>
          Back
        </Button>
      </div>

      {submitError && (
        <Alert variant="danger" className="mb-3">
          {submitError}
        </Alert>
      )}

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          {/* Customer and Address Row */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Select Customer</Form.Label>
              <div className="d-flex gap-2">
                <Form.Select
                  ref={customerRef}
                  name="customer_id"
                  value={formData.customer_id}
                  onChange={handleChange}
                  onKeyPress={(e) => handleKeyPress(e, dateRef)}
                  disabled={loading}
                  isInvalid={!!errors.customer_id}
                >
                  <option value="">Select Customer</option>
                  {customers.map((customer) => (
                    <option key={customer.id} value={customer.id}>
                      {customer.name}
                    </option>
                  ))}
                </Form.Select>
                <Button
                  variant="outline-primary"
                  onClick={handleShowCustomerModal}
                  className="d-flex align-items-center"
                  title="Add New Customer"
                  disabled={loading}
                  type="button"
                >
                  <FaPlus />
                </Button>
              </div>
              {renderError("customer_id")}
            </Form.Group>
          </Col>

          <Col lg={5} md={5} sm={12}>
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                value={selectedCustomerAddress}
                readOnly
                placeholder="Address will appear after selecting customer"
                className="address-field"
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                ref={dateRef}
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
                disabled={loading}
                isInvalid={!!errors.date}
              />
              {renderError("date")}
            </Form.Group>
          </Col>

          {/* Delivery Details */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Vehicle No</Form.Label>
              <Form.Control
                ref={vehicleNoRef}
                name="vehicle_no"
                type="text"
                value={formData.vehicle_no}
                onChange={handleChange}
                placeholder="Enter vehicle number"
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Driver Name</Form.Label>
              <Form.Control
                ref={driverNameRef}
                name="driver_name"
                type="text"
                value={formData.driver_name}
                onChange={handleChange}
                placeholder="Enter driver name"
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Driver Phone</Form.Label>
              <Form.Control
                ref={driverPhoneRef}
                name="driver_phone"
                type="text"
                value={formData.driver_phone}
                onChange={handleChange}
                placeholder="Enter driver phone"
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Delivery Address</Form.Label>
              <Form.Control
                name="delivery_address"
                as="textarea"
                rows={2}
                value={formData.delivery_address}
                onChange={handleChange}
                placeholder="Enter delivery address (leave empty to use customer address)"
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={6}>
            <Form.Group>
              <Form.Label>Bundel Count *</Form.Label>
              <Form.Control
                ref={bundelRef}
                name="bundel_count"
                className="right-align"
                type="number"
                value={formData.bundel_count}
                onChange={handleChange}
                placeholder="Enter Bundel Count"
                min="1"
                onKeyPress={handleQtyKeyPress}
                disabled={loading}
              />
            </Form.Group>
          </Col>

          {/* Invoice Search Row */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group className="position-relative">
              <Form.Label>Order Number</Form.Label>
              <Form.Control
                ref={invoiceNoRef}
                name="invoice_no"
                type="text"
                value={formData.invoice_no}
                onChange={handleChange}
                onFocus={() => {
                  setShowInvoiceDropdown(true);
                  setActiveDropdown('invoice');
                }}
                onBlur={() => setTimeout(() => setShowInvoiceDropdown(false), 200)}
                placeholder="Enter invoice number to auto-fill items..."
                autoComplete="off"
                disabled={loading}
              />

              {showInvoiceDropdown && (
                <div className="custom-dropdown">
                  {getFilteredInvoices().map((invoice, index) => {
                    const invoiceNo = invoice.invoice_no || invoice.id || "";
                    return (
                      <div
                        key={invoice.id || index}
                        className={`dropdown-item ${index === activeIndex && activeDropdown === 'invoice' ? 'active' : ''}`}
                        onClick={() => handleInvoiceSelect(invoice)}
                        onMouseEnter={() => {
                          setActiveIndex(index);
                          setActiveDropdown('invoice');
                        }}
                      >
                        <div className="fw-bold">Order #{invoiceNo}</div>
                        {invoice.customer_name && (
                          <div className="small text-muted">Customer: {invoice.customer_name}</div>
                        )}
                      </div>
                    );
                  })}
                  {getFilteredInvoices().length === 0 && (
                    <div className="dropdown-item text-muted">
                      No invoices found
                    </div>
                  )}
                </div>
              )}
            </Form.Group>
          </Col>

          {/* Product Search Row */}
          <Col lg={6} md={6} sm={12}>
            <Form.Group className="position-relative">
              <Form.Label>Search Product *</Form.Label>

              <Form.Control
                ref={productSearchRef}
                name="productSearch"
                type="text"
                value={formData.productSearch}
                onChange={handleChange}
                onFocus={() => {
                  setShowProductDropdown(true);
                  setActiveDropdown('product');
                }}
                onBlur={() => setTimeout(() => setShowProductDropdown(false), 200)}
                placeholder="Type Product Code or Name..."
                autoComplete="off"
                disabled={loading}
              />

              {showProductDropdown && (
                <div className="custom-dropdown">
                  {getFilteredProducts().map((product, index) => {
                    const productName = product.name || product.product_name || "";
                    const productId = product.id;
                    const productCode = `PROD${productId.toString().length === 1 ? "0" + productId : productId
                      }`;
                    const stock = product.stock || 0;

                    return (
                      <div
                        key={product.id || index}
                        className={`dropdown-item ${index === activeIndex && activeDropdown === 'product'
                            ? 'active'
                            : ''
                          }`}
                        onMouseDown={(e) => {
                          e.preventDefault(); // 🔥 CRITICAL FIX
                          handleProductSelect(product);
                        }}
                        onMouseEnter={() => {
                          setActiveIndex(index);
                          setActiveDropdown('product');
                        }}
                      >
                        <div className="fw-bold">
                          {productCode} - {productName}
                          <span className="text-muted ms-2">
                            (Stock: {stock})
                          </span>
                        </div>
                      </div>
                    );
                  })}

                  {getFilteredProducts().length === 0 && (
                    <div className="dropdown-item text-muted">
                      No products found
                    </div>
                  )}
                </div>
              )}
            </Form.Group>
          </Col>


          <Col lg={3} md={3} sm={6}>
            <Form.Group>
              <Form.Label>Rate *</Form.Label>
              <Form.Control
                ref={rateRef}
                name="rate"
                className="right-align"
                type="number"
                value={formData.rate}
                onChange={handleChange}
                placeholder="Enter Rate"
                min="1"
                // onKeyPress={handleQtyKeyPress}
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={6}>
            <Form.Group>
              <Form.Label>Delivery Qty *</Form.Label>
              <Form.Control
                ref={qtyRef}
                name="qty"
                className="right-align"
                type="number"
                value={formData.qty}
                onChange={handleChange}
                placeholder="Enter Qty"
                min="1"
                onKeyPress={handleQtyKeyPress}
                disabled={loading}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Delivery Items Table */}
        <Row className="mt-4">
          <Col xs={12}>
            <div className="table-responsive">
              <Table bordered className="purchase-table">
                <thead className="table-dark">
                  <tr>
                    <th width="5%">Sno</th>
                    <th width="15%">Product Code</th>
                    <th width="25%">Product Name</th>
                    <th width="15%">Amount</th>
                    <th width="15%">Delivery Qty</th>
                    <th width="15%">Total</th>
                    {/* <th width="15%">Unit</th> */}
                    <th width="10%">Del</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {deliveryItems.map((item, index) => ( */}
                  {deliveryItems.map((item, index) => {
                    // console.log("Delivery Item:", item);
                    console.log("pending_qty:", item.pending_qty);
                    // setTotalAmount(item.selling_rate*item.delivery_qty);
                    return (
                      <tr key={index}
                        className={item.pending_qty == 0 ? 'row-disabled' : ''}
                      // className='row-disabled' 
                      >
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{item.product_code}</td>
                        <td>{item.product_name}</td>
                        <td>{item.selling_rate}</td>
                        <td>
                          <Form.Control
                            type="number"
                            value={item.delivery_qty}
                            className="right-align"
                            onChange={(e) => handleItemChange(index, e.target.value)}
                            placeholder="0"
                            min="1"
                            step="0.01"
                            max={item.current_stock}
                            // disabled={loading}
                            disabled={loading || item.pending_qty == 0}
                          />
                        </td>
                        {/* <td>{totalAmount}</td> */}
                        <td>
                          {(Number(item.selling_rate || 0) * Number(item.delivery_qty || 0)).toFixed(2)}
                        </td>

                        {/* <td className="text-center">{item.unit}</td> */}
                        <td className="text-center">
                          <FaTrash
                            style={{
                              cursor: loading || item.pending_qty == 0 ? 'not-allowed' : 'pointer',
                              opacity: loading || item.pending_qty == 0 ? 0.5 : 1,
                              color: '#dc3545'
                            }}
                            className="delete-icon"
                            // style={{ cursor: loading ? 'not-allowed' : 'pointer', color: '#dc3545', opacity: loading ? 0.5 : 1 }}
                            // onClick={() => !loading && handleDeleteItem(index)}
                            onClick={() =>
                              !(loading || item.pending_qty == 0) && handleDeleteItem(index)
                            }
                            title="Delete Item"
                          />
                        </td>
                      </tr>
                    );
                  }
                  )}
                  {deliveryItems.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-3">
                        {formData.invoice_no
                          ? "Enter invoice number to auto-fill items or manually add items below"
                          : "No items added yet. Enter invoice number to auto-fill or manually add items."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>

        {renderError("items")}

        {/* Totals Section with Notes */}
        <Row className="mt-4">
          <Col lg={8} md={8} sm={12}>
            <Form.Group>
              <Form.Label>Notes (Optional)</Form.Label>
              <Form.Control
                ref={notesRef}
                name="notes"
                as="textarea"
                rows={3}
                value={formData.notes}
                onChange={handleChange}
                placeholder="Enter any notes..."
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12} className="d-flex justify-content-end">
            <div className="totals-section">
              <div className="total-row">
                <span className="total-label">Subtotal:</span>
                <span className="total-value">₹{subTotal.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span className="total-label">
                  GST (
                  <Form.Control
                    type="number"
                    name="gst_percentage"
                    value={formData.gst_percentage || 18}
                    onChange={handleGstChange}
                    className="gst-input"
                    min="0"
                    max="100"
                    step="0.1"
                    disabled={loading}
                  />
                  %)
                </span>
                <span className="total-value">₹{gstAmount.toFixed(2)}</span>
              </div>
              <div className="total-row grand-total">
                <span className="total-label">Grand Total:</span>
                <span className="total-value">₹{grandTotal.toFixed(2)}</span>
              </div>
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            ref={submitBtnRef}
            type="submit"
            className="btn-submit"
            disabled={loading || deliveryItems.length === 0}
          >
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Creating...
              </>
            ) : (
              "Create Delivery Note"
            )}
          </Button>
          <Button
            type="button"
            className="btn-top"
            onClick={() => navigate(-1)}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </Form>

      {/* Add Customer Modal (same as before) */}
      <Modal show={showCustomerModal} onHide={handleCloseCustomerModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add New Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {customerSuccess && (
            <Alert variant="success" className="mb-3">
              {customerSuccess}
            </Alert>
          )}

          {customerErrors.api && (
            <Alert variant="danger" className="mb-3">
              {customerErrors.api}
            </Alert>
          )}

          <Form onKeyDown={handleCustomerKeyDown}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={newCustomer.name}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter customer name"
                    required
                    isInvalid={!!customerErrors.name}
                    autoFocus
                  />
                  {renderCustomerError("name")}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile *</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={newCustomer.mobile}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    required
                    isInvalid={!!customerErrors.mobile}
                  />
                  {renderCustomerError("mobile")}
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                value={newCustomer.address}
                onChange={handleNewCustomerChange}
                placeholder="Enter address"
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={newCustomer.city}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter city"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={newCustomer.state}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter state"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Pin Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="pin_code"
                    value={newCustomer.pin_code}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter pin code"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>GST Number (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    name="gst_no"
                    value={newCustomer.gst_no}
                    onChange={handleNewCustomerChange}
                    placeholder="Enter GST number"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseCustomerModal}
            disabled={isAddingCustomer}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleAddCustomer}
            disabled={!newCustomer.name.trim() || !newCustomer.mobile.trim() || isAddingCustomer}
          >
            {isAddingCustomer ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Adding...
              </>
            ) : (
              "Add Customer"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddDeliveryNote;